export function calculateCycleTotalCost(cycleData: any): number {
  const totalTesters = cycleData.testEnvs.reduce((result, el) => {
    result += el.requiredTesters;
    return result;
  }, 0);

  return totalTesters * cycleData.hoursPerTester * cycleData.hourlyRate;
}
